// services/firebaseService.ts

import { getToken } from "firebase/messaging";
import { auth, messaging } from "../config/firebase";
import { vapid_public_key } from "../config/vapid";
import { GoogleAuthProvider, signInWithPopup, User } from "firebase/auth";

const provider = new GoogleAuthProvider();

export const firebaseService = {
  async getFCMToken(): Promise<string | null> {
    try {
      const permission = await Notification.requestPermission();

      if (permission === "granted") {
        const token = await getToken(messaging, {
          vapidKey: vapid_public_key,
        });
        return token;
      }

      return null;
    } catch (error) {
      console.error("Erreur FCM:", error);
      return null;
    }
  },
  async getFirebaseUser(): Promise<{ id_token: string; user: User }> {
    // 1️⃣ Auth Google via Firebase
    const result = await signInWithPopup(auth, provider);
    const user = result?.user;

    if (!user.email) {
      throw new Error("Impossible de récupérer l'email Google.");
    }

    return {
      id_token: await user?.getIdToken(),
      user: user,
    };
  },
};
